module.exports = "../content/402e33f320299b0fe16b60d4b3db4b1b.png";